var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTransportResponder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E84C07;stroke:#FFFFFF;stroke-width:4.166667e-02;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.4,937.1c-70-19.2-122.1-76.7-134.6-148.8C0,669.6,109.6,559.6,227.5,579.6 c90.8,15.8,155.8,90.8,155.8,180.4C383.3,878.3,268.3,967.5,155.4,937.1z M208.8,870c9.2-11.2,34.6-21.7,63.8-27.1l28.3-4.6 l-1.7-59.2c-1.2-52.9-2.5-60.8-11.7-79.2c-12.1-24.2-30.4-39.6-62.5-53.8l-22.9-10.4l-22.1,8.3c-27.9,10.4-64.2,43.3-71.2,64.6 c-2.9,8.8-6.2,41.7-7.5,72.9l-2.5,56.7l20.4,2.9c35.4,5,70.8,19.6,75.8,32.1C197.5,878.8,202.5,877.1,208.8,870z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.8,764.2c-13.8-13.8-26.7-25-28.8-25c-2.5,0-10.4,5.8-17.9,13.3c-12.1,11.7-14.6,12.5-20,7.1 c-5.4-5.4-3.8-8.8,15.8-27.9L190,710l32.9,33.3c29.6,29.6,32.5,34.2,26.7,39.6C244.2,788.3,240.8,786.3,218.8,764.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransportResponder);
export default __webpack_public_path__ + "static/media/icon_transport_responder.277924484ef9048921a170570b20658b.svg";
export { ForwardRef as ReactComponent };